/* eslint-disable react-hooks/exhaustive-deps */
import get from 'lodash/get'
import { FilterContext } from 'providers/Filter'
import { FilterDataContext } from 'providers/FilterData'
import React, { useContext, useEffect } from 'react'

const SearchEngine: React.FC<any> = (props) => {
  const filterContext = useContext(FilterContext)
  const filterDataContext = useContext(FilterDataContext)
  const policyId = get(props, 'id', '').replace('policy:', '')
  const pageRows = parseInt(get(props, 'rowsPerPage', 9))
  const pageStart = parseInt(get(props, 'startAtPosition', 0))
  const listOrdenation = get(props, 'listOrdenation', '')
  const listPriority = get(props, 'listPriority', '')
  const loadAtStart = get(props, 'loadAtStart', '')
  // const departmentCode = get(props, 'slotTemplateCode', '')

  const loadSearchEngineData = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const searchPageMatcher = new RegExp('\\/pesquisa')
    const tagPageMatcher = new RegExp('\\/tag')
    const urlIsSearchPage = searchPageMatcher.test(window.location.href)
    const urlIsTagPage = tagPageMatcher.test(window.location.href)
    const searchTag = urlIsTagPage && urlParams.get('tag') || ''
    const searchText = urlIsSearchPage && urlParams.get('term') || ''
    filterContext.updateFilter(policyId, {
      date: null,
      departments: [],
      pageRows,
      pageStart
    })
    filterDataContext.loadSearchEngineData({
      policyId,
      pageRows,
      pageStart,
      searchTag,
      searchText
    }, { isSearchEngine: true })
  }

  useEffect(() => { loadSearchEngineData() }, [])

  return <></>
}

export default SearchEngine
